import { useEffect, useState } from 'react';
import axios from 'axios';
import { categoryPath, subcategoryPath } from './catalogPath';

const API = process.env.REACT_APP_BACKEND_URL;
let filledCache = null;

// Marketing words that SEO tags add around a part name ("plaquette de frein pas cher")
const NOISE = /\b(pas cher|pas chers|prix|meilleur|meilleurs|au meilleur prix|acheter|achat|voiture|auto|automobile|en ligne|discount|promo|promotion|neuf|neuve|original|origine|qualit[eé])\b/g;

export const normTag = (s) => (s || '').toString().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  .replace(NOISE, ' ').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
const singular = (s) => s.split(' ').map((w) => (w.length > 4 && w.endsWith('s') ? w.slice(0, -1) : w)).join(' ');

export const useFilledCatalog = () => {
  const [filled, setFilled] = useState(filledCache);
  useEffect(() => {
    if (filledCache) return;
    axios.get(`${API}/api/catalog/filled`).then((r) => { filledCache = r.data; setFilled(r.data); }).catch(() => setFilled({ categories: [], subcategories: [] }));
  }, []);
  return filled;
};

// Resolve a popular-search tag to an indexable category / subcategory page (with products), else null → /recherche fallback
export const resolveTagLink = (tag, categories, filled, excludePath = null) => {
  if (!tag || !categories?.length || !filled) return null;
  const key = singular(normTag(tag));
  if (key.length < 3) return null;
  const hasCat = (c) => filled.categories.includes(c.slug);
  const hasSub = (c, sub) => filled.subcategories.includes(`${c.slug}|${sub}`);
  const candidates = [];
  for (const c of categories) {
    for (const sub of c.subcategories || []) {
      if (!hasSub(c, sub)) continue;
      const k = singular(normTag(sub));
      if (k === key) candidates.push({ score: 3, path: subcategoryPath(c, sub), label: sub });
      else if (k.length >= 5 && (key.includes(k) || k.includes(key)) && Math.min(k.length, key.length) / Math.max(k.length, key.length) >= 0.6) candidates.push({ score: 1, path: subcategoryPath(c, sub), label: sub });
    }
    if (hasCat(c)) {
      const k = singular(normTag(c.name));
      if (k === key) candidates.push({ score: 2, path: categoryPath(c), label: c.name });
      else if (k.length >= 5 && (key.includes(k) || k.includes(key))) candidates.push({ score: 0.5, path: categoryPath(c), label: c.name });
    }
  }
  const best = candidates.filter((x) => x.path !== excludePath).sort((a, b) => b.score - a.score)[0];
  return best || null;
};
